import React, { useEffect, useState } from "react";
import useAuth from "../hooks/useAuth";
import useMatricula from "../hooks/useMatricula";
import { obtenerLabelEtiqueta } from "../utils/idioma/LabelsIdioma";

const ModalSumilla = () => {
  let { listadoAsignaturas, idAsignaturas, gruposHabilitados } = useMatricula();
  const { listadoEtiquetas } = useAuth();
  const [etiquetas, setEtiquetas] = useState({});
  const [equivalentesSinDuplicidad, setEquivalentesSinDuplicidad] = useState(
    []
  );
  useEffect(() => {
    if (listadoEtiquetas.length > 0) {
      setEtiquetas({
        global_sumilla: obtenerLabelEtiqueta(
          "lbl_global_sumilla",
          listadoEtiquetas
        ),
        global_programa: obtenerLabelEtiqueta(
          "lbl_global_programa",
          listadoEtiquetas
        ),
        grupos_equivalente: obtenerLabelEtiqueta(
          "lbl_grupos_equivalente",
          listadoEtiquetas
        ),
        sumilla_aceptar: obtenerLabelEtiqueta(
          "lbl_sumilla_aceptar",
          listadoEtiquetas
        ),
      });
    }
  }, [listadoEtiquetas]);

  useEffect(() => {
    const plantillaSumilla = () => {
      let arrayDuplicados = [];
      let data = gruposHabilitados.filter((e, index) =>
        hash[e.sequivalente] ? false : (hash[e.sequivalente] = true)
      );
      let array = [
        { id: 1, nombre: "casa" },
        { id: 2, nombre: "fruta" },
        { id: 3, nombre: "mascotas" },
        { id: 1, nombre: "casa" },
        { id: 2, nombre: "fruta" },
        { id: 4, nombre: "cosas" },
        { id: 5, nombre: "otros" },
      ];

      let sinRepetidos = gruposHabilitados.filter(
        (valorActual, indiceActual, arreglo) => {

          return (
            arreglo.findIndex(
              (valorDelArreglo) =>
                JSON.stringify(valorDelArreglo) === JSON.stringify(valorActual)
            ) === indiceActual
          );
        }
      );

      array = gruposHabilitados.filter((o) => {

        if (o.scurso == idAsignaturas) {
          return hash[o.sequivalente] ? false : (hash[o.sequivalente] = true);
        }
      });




    };

    function eliminarObjetosDuplicados(arr, prop) {
      var nuevoArray = [];
      var lookup = {};

      for (var i in arr) {
        if (arr[i].scurso == idAsignaturas) {
          lookup[arr[i][prop]] = arr[i];
        }

      }

      for (i in lookup) {
        nuevoArray.push(lookup[i]);
      }

      return nuevoArray;
    }
    var duplicadosEliminados = eliminarObjetosDuplicados(gruposHabilitados, 'sequivalente');

    setEquivalentesSinDuplicidad(duplicadosEliminados);


    plantillaSumilla();
  }, [gruposHabilitados, idAsignaturas]);

  const {
    global_sumilla,
    global_programa,
    grupos_equivalente,
    sumilla_aceptar,
  } = etiquetas;
  let hash = {};
  return (
    <div
      className="modal fade"
      id="sumilla"
      tabIndex="-1"
      aria-labelledby="sumillaLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-md modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title text-uppercase" id="sumillaLabel">
              {global_sumilla}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            {listadoAsignaturas.map(
              ({
                ccurso,
                scurso,
                dcurso,
                dsumilla,
                dequivalente,
                dprograma,
              }) => {
                if (scurso == idAsignaturas) {
                  return (
                    <div key={ccurso}>
                      <p className=" fw-medium mb-0">{dprograma}</p>
                      <div className="group-list">
                        <div className="asign-group-title">
                          <p className="text-uppercase fw-bolder">
                            {scurso} - {dcurso}
                          </p>
                        </div>
                        <div className="asign-group-content">
                          <p className="fw-medium mb-0">{global_sumilla}</p>
                          <p>{dsumilla}</p>
                          <p className="fw-medium mb-0">{grupos_equivalente}</p>

                          {equivalentesSinDuplicidad.length > 0 &&
                            equivalentesSinDuplicidad?.map((e, index) => {
                              if (e.scurso == idAsignaturas) {
                                return (
                                  <p className="" key={index}>
                                    {e.dequivalente}
                                  </p>
                                );
                              }
                            })}
                        </div>
                      </div>
                    </div>
                  );
                }
              }
            )}
          </div>
          <div className="modal-footer text-center">
            <button
              type="button"
              className="btn btn-primary text-center"
              data-bs-dismiss="modal"
            >
              {sumilla_aceptar}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalSumilla;
